import { svg } from 'lit-element';

export const cross = svg`<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 5.39113L18.6089 4L12 10.6089L5.39113 4L4 5.39113L10.6089 12L4 18.6089L5.39113 20L12 13.3911L18.6089 20L20 18.6089L13.3911 12L20 5.39113Z"/></svg>`;
